export function getErrorMessage(error, localeFn = (key) => key) {
  if (error instanceof Error) {
    const { code, response } = error;
    if (code) {
      return localeFn(code, error);
    }
    if (response) {
      const status = response.status;
      if (status) {
        return localeFn(`${status}`, error);
      }
    }
  }
  return localeFn(String((error && error.message) || error), error);
}
